export const selectHomeosiniatria = (state) =>
  state.holonmed.homeosiniatria || [];
